import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function safeSetItem(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    if (e instanceof DOMException && (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED')) {
      console.warn(`LocalStorage quota exceeded for ${key}.`);
      
      // If it's vtc_app_data, try to save a stripped version
      if (key === 'vtc_app_data') {
        try {
          const data = JSON.parse(value);
          let stripped = false;
          
          if (data.settings && data.settings.distanceMatrices && Object.keys(data.settings.distanceMatrices).length > 0) {
            data.settings.distanceMatrices = {}; // Clear distance matrices
            stripped = true;
          }
          
          // If still too large, we could strip more, but distanceMatrices is the most likely culprit
          if (stripped) {
            try {
              localStorage.setItem(key, JSON.stringify(data));
              console.log(`Saved stripped version of ${key} to LocalStorage.`);
              return;
            } catch (e2) {
              console.warn(`Stripped version of ${key} still exceeds quota.`);
            }
          }
        } catch (parseErr) {
          // ignore
        }
      }
      
      // If it's not app_data or stripping didn't work, we might want to clear some space
      // but that's risky. For now, just don't save this item.
    } else {
      console.error(`Error saving to LocalStorage for ${key}:`, e);
    }
  }
}
